import { useEffect } from "react";
import { useWatch } from "react-hook-form";

import { Box, Typography } from "@material-ui/core";

import OperatorStatus from "../../../components/OperatorStatus/OperatorStatus";
import { CustomSwitch } from "../../../components/Switch/Switch";
import MinusIcon from "../../../assets/img/minus.svg";
import PlusIcon from "../../../assets/img/plus.svg";
import OperatorIcon from "../../../assets/img/avatar.png";
import useStyles from "./styles";

const tipsValues = [
  {
    value: 10,
    label: "$10",
    description: "Ok",
  },
  {
    value: 20,
    label: "$20",
    description: "Good",
  },
  {
    value: 50,
    label: "$50",
    description: "Great",
  },
  {
    value: 100,
    label: "$100",
    description: "Perfect",
  },
  {
    value: 150,
    label: "$150+",
    description: "Excellent",
  },
];

const TipsSection = ({
  operatorInfo,
  register,
  defaultTips,
  setValue,
  acceptTips,
}) => {
  const classes = useStyles();
  const tips = useWatch({ name: "tips" })

  useEffect(() => {
    setValue("tips", +defaultTips);
    if (+defaultTips === 0) {
      setValue("acceptTips", false);
    }
  }, [defaultTips]);

  useEffect(() => {
    if (tips > 0) {
      setValue("tips", +tips);
      setValue("acceptTips", true);
    } else {
      setValue("acceptTips", false);
    }
  }, [tips]);


  const handleIncrement = () => {
    const currentTips = +defaultTips;
    setValue("acceptTips", true);
    const incrementValue = (tips) => {
      if (tips >= 150) return 50;
      if (tips >= 100) return 25;
      if (tips >= 50) return 10;
      if (tips >= 20) return 5;
      if (tips >= 10) return 2;
      return 1;
    };
    setValue("tips", currentTips + incrementValue(currentTips));
  };
  const handleDecrement = () => {
    const currentTips = +defaultTips;
    const decrementValue = (tips) => {
      if (tips > 150) return 50;
      if (tips > 100) return 25;
      if (tips > 50) return 10;
      if (tips > 20) return 5;
      if (tips > 10) return 2;
      if (tips > 1) return 1;
    };
    setValue("tips", currentTips - decrementValue(currentTips));
  };

  return (
    <Box className={classes.tipsSection}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        className={classes.tipsSectionMain}
      >
        <OperatorStatus
          logoSrc={operatorInfo?.img || OperatorIcon}
          status={operatorInfo?.online}
        />
        <Box mb={1.5}>
          <Typography variant="h2" align="center">
            How was my service?
          </Typography>
        </Box>
        <Typography variant="body1" align="center">
          If you feel that the service provided was exceptional, you can express
          your gratitude (optional)
        </Typography>
        <Box mt={2}>
          <Typography variant="body2" align="center">
            Select amount to tip:
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.counter}
            mb={3}
          >
            <Box
              onClick={() => handleDecrement()}
              className={classes.counterBtn}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <img src={MinusIcon} alt="minus" />
            </Box>
            <Box className={classes.counterInput} display="flex">
              <input
                type="number"
                name="tips"
                ref={register}
                defaultValue={+defaultTips || 20}
                min={0}
              />
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              onClick={handleIncrement}
              className={classes.counterBtn}
            >
              <img src={PlusIcon} alt="plus" />
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          flexWrap={{ xs: "wrap", sm: "no-wrap" }}
        >
          {tipsValues.map((tip, idx) => (
            <Box
              key={idx}
              className={`${classes.tipBox} ${
                tip.value == defaultTips ? classes.active : null
              }`}
              onClick={() => {
                setValue("tips", +tip.value);
                setValue("acceptTips", true);
              }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="body2">{tip.description}</Typography>
              <Typography variant="body1">{tip.label}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box className={classes.tipsSectionSecondary}>
        <Box mb={1}>
          <CustomSwitch
            name="acceptTips"
            value={acceptTips}
            label={
              <Typography variant="subtitle1" color="secondary">
                I agree that this amount will be charged in addition to the cost of the airline ticket(s).
              </Typography>
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TipsSection;
